import React from "react"
import s from "./CopyableText.module.css"
import { NotificationService } from "../../features/NotificationService/NotificationService"
import { Button } from "@radix-ui/themes"

const CopyableText: React.FC<{ children: string }> = ({ children }) => {
  const handleCopy = () => {
    navigator.clipboard
      .writeText(children)
      .then(() => {
        NotificationService.showNotification({
          message: "Текст скопирован в буфер обмена",
          level: "success",
          hideAfter: 2000,
        })
      })
      .catch((error) => {
        NotificationService.showNotification({
          message: "Ошибка при копировании текста",
          level: "error",
          errorBody: error,
          hideAfter: 2000,
        })
      })
  }

  return (
    <div>
      <p className={s.text}>{children}</p>
      <Button onClick={handleCopy}>Скопировать текст</Button>
    </div>
  )
}

export default CopyableText
